import { MONDAYWORKSPACE_FAIL, MONDAYWORKSPACE_SUCCESS } from "../actionTypes";

const initialState = {
  loading: false,
  error: null,
  user: null,
};

export default function mondayWorkspaceReducer(state = initialState, action) {
  switch (action.type) {
    case MONDAYWORKSPACE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: action.payload.user,
      };

    case MONDAYWORKSPACE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ? action.payload.error : true,
        user: null,
      };

    default:
      return state;
  }
}
